
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import value2name from 'vux/src/filters/value2name.js'


export default {
components: {
XHeader,
XInput,
Group,
XAddress
},
data () {
return {
enterpriseusers:{}
}
},
beforeRouteEnter(to, from, next){
next(vm => {
vm.$http.get('/api/v1/companys/mmm005')
.then(function(response){
if (response.data.detail){
vm.enterpriseusers = response.data;
}
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/enterpriseUsers.vue